import React from 'react';

export const Logo = ({ compact, className, style }) => {
    return (
        <div className={className} style={{ display: 'flex', alignItems: 'center', gap: compact ? '0' : '10px', ...style }}>
            <svg width={compact ? "32" : "36"} height={compact ? "32" : "36"} viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
                <defs>
                    <linearGradient id="logo-grad" x1="0" y1="0" x2="512" y2="512" gradientUnits="userSpaceOnUse">
                        <stop offset="0%" stopColor="#8b5cf6" />
                        <stop offset="50%" stopColor="#a855f7" />
                        <stop offset="100%" stopColor="#ec4899" />
                    </linearGradient>
                </defs>
                <circle cx="256" cy="256" r="192" stroke="url(#logo-grad)" strokeWidth="80" fill="none" />
                <circle cx="410" cy="140" r="18" fill="url(#logo-grad)" opacity="0.6" />
                <circle cx="410" cy="140" r="9" fill="white" />
            </svg>

            {!compact && (
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <div style={{
                        fontSize: '20px',
                        fontWeight: 700,
                        letterSpacing: '-0.02em',
                        color: '#36383B',
                        lineHeight: '1.1'
                    }}>
                        Out<span style={{
                            background: 'linear-gradient(135deg, #8b5cf6 0%, #ec4899 100%)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent'
                        }}>CRM</span>
                    </div>
                    <div style={{
                        fontSize: '9px',
                        fontWeight: 500,
                        color: '#A3A7B0',
                        letterSpacing: '0.06em',
                        textTransform: 'uppercase',
                    }}>
                        by 2Yay Digital Group
                    </div>
                </div>
            )}
        </div>
    );
};
